import { TelevisionClassicIcon } from './TelevisionClassicIcon';

/**
 * author: GreenTurtwig
 * id EB7FD483-EAF9-4FEE-8B82-25186D26827A
 * name television-classic
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/television-classic.svg
 * tags
 * - Device / Tech 
 * - Home Automation 
 */
export const TvClassicIcon = TelevisionClassicIcon;
export default TvClassicIcon